import withErrorBoundary from "src/components/errorBoundary/withErrorBoundary";
import { IntegrationCapability, IntegrationCapabilityList } from 'src/types/settings/dashboard'
import { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import _, { forEach } from "lodash";
import DOMPurify from 'dompurify';
import cx from "classnames";
import styles from "./styles.module.scss";
import UserAvatar from "../components/userAvatar";
import Actions from "src/components/actionbar";
import IntegrationCard from "../components/integrationCard";
import { useCapabilitiesFetch } from "src/query/settings/dashboard";
import { ActionNeeded, VersionUpdate } from "../components/smartCards";
import Slider from 'src/components/slider';
import Button from 'src/components/button';
import { useTinyMce } from "src/components/useTinyMce";
import InputGroup from "src/components/inputGroup";
import { ProfileEnum, profileDetails, resetPassword, resetPasswordErrorLabels, applicationPlatformTypes , externalLinkTypes , CapabilityCategoriesEnum , CapabilityPlatformTypesEnum  , externalLinksMapping, applicationQRCodeMapping, adminOnlyCapabilityTypes, newVersionAvailableInfo } from "src/types/settings/profile";
import StackProgressBar from "../components/stackProgressbar";
import { useEmailSignatureUpdate, usePasswordUpdate, useUserFetch, useUserUpdate, useCapabilitiesActionNeededFetch, useActivatedKeysFetch } from "src/query/settings/profile";
import { useIntegrationsQuery } from "src/query/settings/integrations";
import { getIntegrationPath } from 'src/utils/util';
import AssetIconEditor from "src/legacy/components/AssetIconEditor/view";
import GenerateQRCode from "src/components/generateQRCode";
import { toast } from "react-toastify";
import Toast from "src/components/toast";
import { useProfileAdoption } from "src/query/settings/adoption/profile";
import { useDispatch } from "react-redux";
import { fetchUserProfile } from "src/redux/actions/users";
import IntegrationValidateView from "src/legacy/pages/settings/integrations/integrations/IntegrationConfirmView";
import SlidePaneView from "src/legacy/components/SlidePaneView";

const NoIntegrations = '/images/settings/no_integrations.svg';
const emptySignature = '/images/settings/empty_email_signature.svg';
const BrowserControlBar = '/images/settings/browser_control_bar.png';


export const defaultManagePassword = {
  [ProfileEnum.oldPassword]:'',
  [ProfileEnum.newPassword1]: '',
  [ProfileEnum.newPassword2]: '',
}

function Profile() {

  const navigate = useNavigate();

  const {data: user, isLoading: isLoadinguser} = useUserFetch();
  const { data: capabilities, isLoading: isLoadingCapabilities } = useCapabilitiesFetch();
  const { data: integrations, isLoading: isLoadingIntegrations } = useIntegrationsQuery();
  const { mutate: updateUser, isPending: isUserPending, status: isUserStatus, error: userErrorMsg } = useUserUpdate();
  const { mutate: updatePassword, isPending: isPasswordPending, status: isPasswordStatus, error: passwordErrorMsg  } = usePasswordUpdate() as any;
  const { data: capabilitiesActionNeeded } = useCapabilitiesActionNeededFetch();
  const { data: activatedKeys, isLoading: actionKeysLoading} = useActivatedKeysFetch();
  const { trackProfileClicked } = useProfileAdoption();

  const userAvatar = _.get(user, 'icon.full', '');

  const enabledIntegrations = _.filter(capabilities, (capability) => capability?.enabled);
 
  const notActivatedAndEnabledIntegrations: IntegrationCapability[] = useMemo(() => {
    return _.filter(enabledIntegrations, (capability) => {
      const type = capability?.productCapabilityResponse?.type;
      return (
        capability?.productCapabilityResponse?.category?.type === "USER_SPECIFIC" &&
        !activatedKeys?.includes(type) &&
        capability?.productCapabilityResponse?.integration
      );
    });
  }, [activatedKeys]); // dependency 

  const [selectedCapablitites, setSelectedCapablities] = useState<IntegrationCapability[]>([]);
  const [showUpdateProfileSlider, setShowUpdateProfileSlider] = useState<boolean>(false);
  const [showUpdatePasswordSlider, setShowUpdatePasswordSlider] = useState<boolean>(false);
  const [manageProfile, setManageProfile] = useState<profileDetails | null>(null);
  const [managePassword, setManagePassword] = useState<resetPassword>(defaultManagePassword)
  const [errorMessages, setErrorMessages] = useState<Record<string, string>>({});
  const [showDownloadDeviceSlider, setShowDownloadDeviceSlider] = useState<boolean>(false);
  const [selectedDownloadDevice, setSelectedDownloadDevice] = useState<IntegrationCapability | null>(null)
  const [showimageEditor, setShowImageEditor] = useState<boolean>(false);
  const inputFileRef = useRef<HTMLInputElement>(null);
  const [showInValidEmailSlider, setShowInValidEmailSlider] = useState<boolean>(false);
  const [selectedEmailIntegration, setSelectedEmailIntegration] = useState<string | null>(null);

  /* Methods */
  useEffect(() => { // Mount
    trackProfileClicked(); // event
  },[]);

  useEffect(() => {
    if(user){
      setManageProfile(user);
    }
  },[user])

  useEffect(() => {  
    if(_.size(capabilities) > 0 && _.size(integrations) > 0) {
     let enableUserCapablities = _.filter (capabilities, (capability) =>  capability.enabled && capability.productCapabilityResponse?.category?.type  === 'USER_SPECIFIC'); 
     if(user && !user.admin){ // remove some stacks,
       enableUserCapablities = _.filter(enableUserCapablities, (capability) => !adminOnlyCapabilityTypes.includes(capability.productCapabilityResponse.type));
     };
     if(_.size(enableUserCapablities) > 0) {
        setSelectedCapablities(() =>
          _.map(enableUserCapablities, (capability) => {
            const type = capability.productCapabilityResponse.type;

            if(_.includes(activatedKeys, type)) { // completed
                capability.status = 'activated'; 
            } else { // pending
                capability.status = 'deActivated';
            }
            
            return capability;
          })
         )
        return;
      };
    }
    setSelectedCapablities([]); // empty
  }, [capabilities,integrations, activatedKeys]);

  useEffect(() => {
    if(showUpdateProfileSlider || showimageEditor){  // user
        if(isUserStatus === 'success'){
          setShowUpdateProfileSlider(false);
          setShowImageEditor(false);
          if (inputFileRef.current) {
             inputFileRef.current.value = ""; // clear after upload
          }
          toast(
              <Toast.Sucess
                        message="Updated Sucessfully"
                    />, {
                    autoClose: 3000,
          })
        } else if(isUserStatus === 'error') {
            toast(
              <Toast.Failure
                        message={`error in updating profile`}
                    />, {
                autoClose: 3000,
            });
        }
    }

    if(showUpdatePasswordSlider){ // password
       if(isPasswordStatus === 'success'){
          setShowUpdatePasswordSlider(false);
          toast(
           <Toast.Sucess
                        message="Updated Sucessfully"
                    />, {
                    autoClose: 3000,
          })
      } else if(isPasswordStatus === 'error') {
          if(passwordErrorMsg && _.size(passwordErrorMsg) > 0){
            _.forEach(passwordErrorMsg.errors,
              (err) => { 
                setErrorMessages((prev) => ({...prev, 
                   ...((err.code === "password.old.match" || err.code === "password.previous.match") && {'oldPassword':  `${err.message}`}),
                   ...((err.code === "password.new.match" || err.code === "password.invalid.length") && {'newPassword1':  `${err.message}`})
                }));
            });
          };
      } 
     }
  }, [isUserStatus, isPasswordStatus])


  // profile Details
  const handleChangeProfile = (e: React.ChangeEvent<HTMLInputElement>) => { // field change
     const { name: key, value} = e.target;
     setManageProfile((prev) => ({...prev, [key]: value}));
  }

  const handleSaveProfile = (icon?: string | undefined) => { // submit
    if(manageProfile && manageProfile[ProfileEnum.firstName]){ // check for only firstName
       setErrorMessages({}); //reset
       const reqBody = {
        [ProfileEnum.email]: manageProfile[ProfileEnum.email],
        [ProfileEnum.firstName]: manageProfile[ProfileEnum.firstName],
        [ProfileEnum.lastName]: manageProfile[ProfileEnum.lastName],
        [ProfileEnum.icon]: icon ?? null,
        [ProfileEnum.mobilePhone]: manageProfile[ProfileEnum.mobilePhone],
        [ProfileEnum.title]: manageProfile[ProfileEnum.title],
        [ProfileEnum.workPhone]: manageProfile[ProfileEnum.workPhone],
       };
       updateUser(reqBody); // api call
    } else {
       setErrorMessages((prev) => ({...prev,[ProfileEnum.firstName]: 'invalid first name'}));
    }
  }

  const handleCloseProfile = () => { //reset
     setManageProfile(user);
     setErrorMessages({}); 
     setShowUpdateProfileSlider(false);
  }

  // reset Password
  const handleChangePassword = (e: React.ChangeEvent<HTMLInputElement>) => {// field change
     const { name: key, value} = e.target;
     setManagePassword((prev) => ({...prev, [key]: value}));
  }

  const handleSavePassword = () => { // submit
      if(managePassword[ProfileEnum.oldPassword] && managePassword[ProfileEnum.newPassword1] && managePassword[ProfileEnum.newPassword2]){
        setErrorMessages({}); //reset
        const reqBody = {
          [ProfileEnum.oldPassword]: managePassword[ProfileEnum.oldPassword],
          [ProfileEnum.newPassword1]: managePassword[ProfileEnum.newPassword1],
          [ProfileEnum.newPassword2]: managePassword[ProfileEnum.newPassword2],
        }
        updatePassword(reqBody); // api call
      } else {
          _.forEach(managePassword,
             (value, key) => { 
              if(managePassword[key]){  // remove
                 setErrorMessages((prev) => {
                    let previousValues = prev;
                    delete previousValues[key];
                    return previousValues;
                 })
              } else { // add
                setErrorMessages((prev) => ({...prev,[key]:  `${resetPasswordErrorLabels[key]} is required.`})); 
              }
          });
      }
  }

  const handleClosePassword = () => { // reset
    setManagePassword(defaultManagePassword);
    setErrorMessages({}); 
    setShowUpdatePasswordSlider(false);
  }

  // action needed or integrations
  const handleIntegrationClick = (integration: IntegrationCapability) => {
      const integrationType = integration.productCapabilityResponse?.type;
      if (integrationType) {
        if(integration.productCapabilityResponse.category.name === "EMAIL"){ // Email integrations
          const activatedEmailIntegration = getActivatedEmailIntegration();
          if(activatedEmailIntegration){ // already activated
            if(activatedEmailIntegration !== integration.productCapabilityResponse.type){ // not the activated email integration
              setSelectedEmailIntegration(integration.id);
              setShowInValidEmailSlider(true);
              return true;
            }
          } 
        }
        // Navigate to the integration setup page
        const getPath = getIntegrationPath(integrationType);
        if (getPath) {
          navigate(`/settings/integrations/${getPath.toLowerCase()}?source=profile`);
        }
      }
  }
  
  // applications
  const handleDownloadApplications = (capability: IntegrationCapability) => { 
      setSelectedDownloadDevice(capability);
      setShowDownloadDeviceSlider(!showDownloadDeviceSlider);
  }

  const handleCloseDownloadApplications = () => {
      setSelectedDownloadDevice(null);
      setShowDownloadDeviceSlider(false);
  }

  // links
  const handleExternalLinks = (type: string) => {
    window.open(externalLinksMapping[type], "_blank", "noopener,noreferrer"); // open in new tab
  }

  // render integration status
  const renderIntegrationStatus = (capability: IntegrationCapability) => { 
    const type = capability.productCapabilityResponse.type;
    if(capability.productCapabilityResponse.integration){ // integrations
          return ( <IntegrationStatus 
                    type={CapabilityCategoriesEnum.integration} 
                     enabled={capability.status === 'activated'} /> 
                  )
    } else if(applicationPlatformTypes.includes(type as CapabilityPlatformTypesEnum)) { // applications
          return (
            <IntegrationStatus  
                     type={CapabilityCategoriesEnum.application}  
                     enabled={capability.status === 'activated'} />
          )
    } else if(externalLinkTypes.includes(type as CapabilityPlatformTypesEnum)) { // links
        return <IntegrationStatus  
                  type={CapabilityCategoriesEnum.link}  
                  enabled={capability.status === 'activated'} />
     }
  }

  // profile pic change
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
     const file = e.target.files ? e.target.files[0] : null;
     if (!file) return;

     const maxSize = 2 * 1024 * 1024; // 2MB
     
     if (file.size <= maxSize) {
       setShowImageEditor(true);
     } else { // file size exceeds limit
        toast(
              <Toast.Failure
                message="File size exceeds 2MB. Please select a smaller image."
              />,
              {
                autoClose: 2000,
              }
       );
            
       if (inputFileRef.current) { // clear
                inputFileRef.current.value = ""; 
       }
    }  
  }
  
  const handleResetFile = () => { // reset file
      setShowImageEditor(false); 
      if (inputFileRef?.current) { // clear
        inputFileRef.current.value = ""; 
      }
  }

  // Get the activated email integration type
  const getActivatedEmailIntegration = () => {
    const typeOfEmailIntegrations = ['outlook_integration', 'gmail_integration', 'smtp_integration'];
    return _.filter(typeOfEmailIntegrations, type => _.includes(activatedKeys, type))[0];
  }

  // handle capabilities click
  const handleCapabilitiesClick = (capability: IntegrationCapability) => {
    const type = capability.productCapabilityResponse.type;
    if(capability.productCapabilityResponse.integration){ // integrations
          return handleIntegrationClick(capability);
    } else if(applicationPlatformTypes.includes(type as CapabilityPlatformTypesEnum)) { // applications
          return handleDownloadApplications(capability);
    } else if(externalLinkTypes.includes(type as CapabilityPlatformTypesEnum)) { // links
          return handleExternalLinks(type);
     }
  }

  return (
    <>
     { !isLoadinguser && !isLoadingIntegrations && !isLoadingCapabilities && !actionKeysLoading ? <div className={cx(styles.container)}>
      <div className={cx(styles.header)}>
               <div className={cx(styles.headerContent)}>
                  <UserAvatar src={userAvatar} isEdit={true} handleClick={() => inputFileRef.current && inputFileRef.current.click()}/>
                  <div className={cx(styles.headerInfo)}>
                    <p className={cx(styles.name)} >{_.get(user, 'firstName', '')} {_.get(user, 'lastName', '')}</p>
                    <p className={cx(styles.email)}>{_.get(user, 'email')}</p>
                  </div>
               </div>

             <div className={cx(styles.headerActionBtns)}>
               <Actions.Button
                width={3}
                icon={"paperflite-edit"}
                title="edit profile"
                onClick={() => {
                    setShowUpdateProfileSlider(!showUpdateProfileSlider);
                }}
                />

                <Actions.IconButton
                icon={"paperflite-request-access"}
                onClick={() => {
                    setShowUpdatePasswordSlider(!showUpdatePasswordSlider);
                }}
                />
             </div>
        </div>
        <div className={cx(styles.contentContainer)}>
            <div className={cx(styles.integrations)}>
             { _.size(selectedCapablitites) > 0 &&  <StackProgressBar stacks={selectedCapablitites} classnames={styles.stackProgress}/>}
                <div className={cx(styles.integrationsContainer)}>
                   <p className={cx(styles.description)}>Here’s a list of integrations ready for you to set up.</p>
                   <div className={cx(styles.integrationsContent)}>
                        {  _.size(selectedCapablitites) > 0 ? <>  
                            { _.map(selectedCapablitites, (capability: IntegrationCapability) => (
                              <IntegrationCard  
                                    key={capability.id}
                                    type="integration" 
                                    title={capability.productCapabilityResponse.name}
                                    subTitle={capability.productCapabilityResponse.description}
                                    iconUrl={capability.productCapabilityResponse.icon}
                                    className={styles.integrationCard}
                                    status={
                                        renderIntegrationStatus(capability)
                                      }
                                    handleClick={() => handleCapabilitiesClick(capability)  }
                                    />
                           ))}                    
                       </> : <>
                            <IntegrationPlaceholder/>
                            <EmptyIntegration/>
                     </> }
                   </div>
                </div>
            </div>   

            <div className={styles.rightPane}>
             {(_.size(capabilitiesActionNeeded) > 0 || _.size(notActivatedAndEnabledIntegrations) > 0) && 
              <div className={styles.actionNeeded}>
              <p className={styles.title}>action needed</p>

              <div className={styles.innerContainer}>

              {_.size(capabilitiesActionNeeded) > 0 && capabilitiesActionNeeded.map((item: any, index: number) => (
                  <ActionNeeded 
                       key={index} 
                       isIntegrated={true} 
                         classnames={styles.content} 
                       name={item?.productCapabilityResponse?.name} 
                       icon={item?.productCapabilityResponse?.icon}
                       handleClick={() => handleIntegrationClick(item)}
                   />
              ))}

              {_.size(notActivatedAndEnabledIntegrations) > 0 && notActivatedAndEnabledIntegrations?.map((item, index: number) => (
                <ActionNeeded 
                 key={index} 
                 classnames={styles.content} 
                 isIntegrated={false} 
                 name={item?.productCapabilityResponse?.name} icon={item?.productCapabilityResponse?.icon}
                 handleClick={() => handleIntegrationClick(item)}
                />))}
             </div>
            </div>}

               {/* { _.map(newVersionAvailableInfo, (info, itemKey) => (
                  <div key={itemKey} className={styles.versionUpdate}>
                      <p className={styles.title}>new version available</p>
                      <VersionUpdate version={info.version} qrLink={info.qrLink} deviceName={info.deviceName} />
                    </div> 
                ))} */}
 
                <div className={styles.notifications}>
                    <p className={styles.title}>notifications</p>
                    <div>
                      <p className={styles.subText}>Stay up-to-date with real-time updates. Configure your notifications today.</p>
                      <Link className={styles.actionItem} to={'/settings/notifications'}>  <i className='paperflite-right-arrow'/>  Set up now </Link>
                    </div>
                </div>

                  <RenderEmailSignature signature={_.get(user,'emailSignature')}/>
            </div>   
        </div> 

      <Slider.Dialog
        width="380px"
        show={showUpdateProfileSlider}
        onClose={handleCloseProfile}
        className={styles.slider}
      >
        <Slider.Header
          title="Manage profile"
          message="Edit your profile information shown when sharing collections." />
        <Slider.Body>
          
           <div className={styles.manageProfile}>
                <InputGroup
                   label="first Name"
                   name={ProfileEnum.firstName}
                   value={manageProfile?.firstName}
                   onChange={handleChangeProfile}
                   errorMessage={_.size(errorMessages) > 0 ? errorMessages[ProfileEnum.firstName] : undefined}
                />

                 <InputGroup
                   label="last Name"
                   name={ProfileEnum.lastName}
                   value={manageProfile?.lastName}
                   onChange={handleChangeProfile}
                />

                 <InputGroup
                   label="title"
                   name={ProfileEnum.title}
                   value={manageProfile?.title}
                   onChange={handleChangeProfile}
                />
                 <InputGroup
                   label="email"
                   name={ProfileEnum.email}
                   value={manageProfile?.email}
                   onChange={handleChangeProfile}
                   disabled={true}
                />

                 <InputGroup
                   label="work phone"
                   name={ProfileEnum.workPhone}
                   value={manageProfile?.workPhone}
                   onChange={handleChangeProfile}
                />

                 <InputGroup
                   label="mobile"
                   name={ProfileEnum.mobilePhone}
                   value={manageProfile?.mobilePhone}
                   onChange={handleChangeProfile}
                />
           </div>
        </Slider.Body>

        <Slider.Actions>
          <Button variant="primary" icon='paperflite-tick' text={isUserPending ? "Updating..." : "Confirm"}  disabled={isUserPending}  onClick={() => handleSaveProfile()}></Button>
          <Button variant="secondary" text="Cancel" disabled={isUserPending} onClick={handleCloseProfile}></Button>
        </Slider.Actions>
      </Slider.Dialog>


      <Slider.Dialog
        width="380px"
        show={showUpdatePasswordSlider}
        onClose={handleClosePassword}
        className={styles.slider}
      >
        <Slider.Header
          title="Manage password"
          message="Change your account password." />
        <Slider.Body>
           <div className={styles.managePassword}>
                <InputGroup
                   label="old Password"
                   type="password"
                   name={ProfileEnum.oldPassword}
                   value={managePassword.oldPassword}
                   onChange={handleChangePassword}
                   errorMessage={_.size(errorMessages) > 0 ? errorMessages[ProfileEnum.oldPassword] : undefined}
                />

                 <InputGroup
                   label="new Password"
                   type="password"
                   name={ProfileEnum.newPassword1}
                   value={managePassword.newPassword1}
                   onChange={handleChangePassword}
                   errorMessage={_.size(errorMessages) > 0 ? errorMessages[ProfileEnum.newPassword1] : undefined}
                />

                 <InputGroup
                   label="Re-enter New Password"
                   type="password"
                   name={ProfileEnum.newPassword2}
                   value={managePassword.newPassword2}
                   onChange={handleChangePassword}
                   errorMessage={_.size(errorMessages) > 0 ? errorMessages[ProfileEnum.newPassword2] : undefined}
                />
           </div>
        </Slider.Body>

        <Slider.Actions>
          <Button variant="primary" icon='paperflite-tick' text={isPasswordPending ? "Updating..." : "Confirm"}  disabled={isPasswordPending}  onClick={handleSavePassword}></Button>
          <Button variant="secondary" text="Cancel" disabled={isPasswordPending} onClick={handleClosePassword}></Button>
        </Slider.Actions>
      </Slider.Dialog>

        <Slider.Dialog
        width="380px"
        show={showDownloadDeviceSlider}
        className={styles.downloadDevices}
        onClose={handleCloseDownloadApplications}
      >
         <Slider.Header
          title={
          <div className={styles.headerContainer}>
              <h2 className={styles.header}>Download Device</h2>
              <button className={styles.closeButton} onClick={handleCloseDownloadApplications}>
                <i className="paperflite-close" />
              </button>
          </div>
         }
         message="Get Paperflite on your mobile device."/>
        <Slider.Body>
           { selectedDownloadDevice &&
            <div className={styles.innerContainer}> 
                <p className={styles.title}> {selectedDownloadDevice.productCapabilityResponse.name} </p>
                <div className={styles.downloadDevicesContent}>
                    <GenerateQRCode value={applicationQRCodeMapping[selectedDownloadDevice.productCapabilityResponse.type]}/>
                    <div>
                        <p className={styles.subText}> scan this QR to download the application.</p>
                    </div>
                </div>
           </div>
         }
        </Slider.Body>
      </Slider.Dialog>


      { showInValidEmailSlider && 
     <SlidePaneView  width="30vw" show={showInValidEmailSlider}>
       <IntegrationValidateView 
        activatedIntegration={_.find(integrations, { key: getActivatedEmailIntegration() })}
        clickedIntegration={_.find(selectedCapablitites, { id: selectedEmailIntegration })}
        onCancel={() => {
          setShowInValidEmailSlider(false);
          setSelectedEmailIntegration(null);
        }} 
       />
       </SlidePaneView>
       }

       { showimageEditor && inputFileRef?.current?.files?.[0] && 
         <ImageEditor 
          file={inputFileRef?.current?.files[0]} 
          onClose={() => handleResetFile()}
          onUploadClick={(val) => handleSaveProfile(val)}
          />}

        {/* Upload */}
         <input className={styles.profileUpload} accept="image/*" ref={inputFileRef} type="file" onChange={handleFileChange}/>
       </div> : 
       <div className={cx(styles.loading)}>
            <p>Loading...</p>
       </div> }
    </>
    
  );
}

export const EmptyIntegration = () => {
    return (
       <div className={cx(styles.emptyIntegration)}>
            <img className={cx(styles.noIntegrationsImg)} src={NoIntegrations} alt="no Integrations" />
            <p className={cx(styles.noIntegrationsText)}>No integrations to implement yet!</p>
        </div>
    )
}

export const IntegrationStatus = ({type, enabled, onClick}: {type: CapabilityCategoriesEnum ,enabled: boolean, onClick?: () => void}  ) => {
    return (
      <>
          <button className={styles.integrationStatus} onClick={onClick}>
            { type === CapabilityCategoriesEnum.integration ?
               <>
             <i className={cx(( enabled ? 'paperflite-tick' : 'paperflite-right-arrow'),styles.icon)} /> 
             {!enabled  && 'open integration' }
              </>
               : 
                type === CapabilityCategoriesEnum.application ? 
                   <>
                     <i className={cx(( enabled ? 'paperflite-tick' : 'paperflite-right-arrow'),styles.icon)} />
                      {!enabled && 'download' }
                   </> : 
                   <> 
                   <i className={cx(( enabled ? 'paperflite-tick' : 'paperflite-right-arrow'),styles.icon)} />
                      {!enabled && 'open link' }
                  </>
             }
          </button>
       </>
    )
}

export const IntegrationPlaceholder = () => {
    return (
        <div className={cx(styles.integrationPlaceholder)}>
            <div className={cx(styles.circle)}></div>
            <div className={cx(styles.hr)}></div>
        </div>
    )
}

export const RenderEmailSignature = ({signature} :{signature: string | undefined}) => {

  const { mutate: updateEmailSign, isPending: isEmailSignPending, status: isEmailSignStatus, error: emailSignatureError } = useEmailSignatureUpdate();
  const { trackEmailSignatureAdded } = useProfileAdoption();
  const dispatch = useDispatch(); // dispatch

  const {Renderer: EmailSignatureViewer , TinyMce: EmailSignatureEditor , output: updatedEmailSignature, reset: resetEmailSignature } = useTinyMce(signature ?? '');

  const [showEmailSignatureSlider, setShowEmailSignatureSlider] = useState<boolean>(false);

  /* Methods */
  useEffect(() => {
     if(showEmailSignatureSlider){ // email signature
        if(isEmailSignStatus === 'success') {
          trackEmailSignatureAdded(); // event
          setShowEmailSignatureSlider(false);
          dispatch(fetchUserProfile()); // to reflect the changes in store
          toast(
              <Toast.Sucess
                        message="Updated Sucessfully"
                    />, {
                    autoClose: 3000,
          })
        } else if (isEmailSignStatus === 'error') {
            toast(
              <Toast.Failure
                        message={`error in updating email signature`}
                    />, {
                autoClose: 3000,
            });
        }
     }
  }, [isEmailSignStatus])

  const handleChangeEmailSignature = () => {
   const reqBody ={
    emailSignature: updatedEmailSignature,
   }
   updateEmailSign(reqBody);
  }

  const handleCloseEmailSignature = () => { // reset
    setShowEmailSignatureSlider(false);
    resetEmailSignature();
  }
  
  return ( 
    <>
      <div className={styles.emailSignature}>
              <p className={styles.title}>email signature</p>
              <div className={styles.contentWrapper}>
                      <p className={styles.content}>
                        { !signature ? <i className={cx('paperflite-danger', styles.icon )}/> 
                           : <i className={cx('paperflite-tick-selected', styles.icon)}/>}
                        { !signature ? 'Email signature is pending.' : 'Email signature has been successfully added.'}
                      </p>
                      <p
                         className={styles.action}
                         onClick={() => setShowEmailSignatureSlider(!showEmailSignatureSlider)}>
                          <i className="paperflite-right-arrow" /> { !signature ? 'Add' : 'Update'} Signature
                      </p>
              </div>
              { !signature && <img className={styles.emptyEmailSignature} src={emptySignature} alt="empty Signature"/> }                       
      </div>

    <Slider.Dialog
        width="auto"
        show={showEmailSignatureSlider}
        onClose={handleCloseEmailSignature}
        className={styles.slider}
      >
        <Slider.Header
          title="Email signature"
          message="Create a professional email signature that appears in all your outgoing emails and templates." />
        <Slider.Body>
           <div className={styles.updateEmailSignature}>
                <div className={styles.preview}>
                      <img src={BrowserControlBar} alt="" />
                      <div className={styles.compose}>
                        <div>
                            <p className={styles.composeHeader}> Compose</p>
                           <p className={styles.composeContent}>quick send</p>
                        </div>
                        <div className={styles.innerContainer}>
                              <div className={styles.input}>
                                      <p className={styles.preText}>To</p>
                              </div>
                               <div className={styles.input}>
                                      <p className={styles.preText}>Subject</p>
                              </div>
                        </div>

                        <div>
                               <p className={styles.composeContent}> Hello there,
                                <br/>
                                  This is a sample email created for preview purposes, intended to <br/> demonstrate formatting, layout, and overall presentation.
                                  <br/> <br/>
                                Thank you!
                              </p>
                        </div>

                        <div className={styles.previewSignature}>
                          <div className={styles.restrictEvents}>
                                 <EmailSignatureViewer/>
                          </div>
                        </div>
                      </div>
                </div>
                <div className={styles.editor}>
                   <p>Insert your custom signature here, This is a default feature in all outgoing emails or new email templates.</p>
                  <EmailSignatureEditor classnames={styles.editSignature}/> 
                </div>
           </div>
        </Slider.Body>

        <Slider.Actions>
          <Button variant="primary" icon='paperflite-tick'  text={isEmailSignPending ? "Updating..." : "Confirm"}  disabled={isEmailSignPending}  onClick={handleChangeEmailSignature}></Button>
          <Button variant="secondary" text="Cancel" disabled={isEmailSignPending} onClick={handleCloseEmailSignature}></Button>
        </Slider.Actions>
      </Slider.Dialog>

    </>

  )
}

export const ImageEditor = ({file, onUploadClick, onClose}: {file: any, onUploadClick: (string) => void, onClose: () => void }) => {
  return (
            <AssetIconEditor
                          crop={{
                            x: 0,
                            y: 0,
                            width: 100,
                            height: 100,
                            unit: "%",
                            aspect: 1
                          }}
                          cropType='circle'
                      show={true}
                     image={file}
                              collectioName = {''}
                           onChange={onUploadClick}
                           trackAdoptionMetricsForAddLogoUploadClickedEvent={() => console.log("")}
               onCancel={onClose}
             />
  )
}

export default withErrorBoundary(Profile); 